<template>
    <MobileSports/>
    <section class="cricket-tabs-section" loading="lazy" id="tabs-header">
        <div class="remove-padding">
            <div class="favourate-leagues-tabs">
                <ul class="nav nav-pills" id="pills-tab" role="tablist">
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" :class="{ 'active': selectedTab === 'matches' }" id="pills-live-upcoming-tab" data-bs-toggle="pill"
                            data-bs-target="#pills-live-upcoming" type="button" role="tab"
                            aria-controls="pills-live-upcoming" aria-selected="true" @click="selectedTab = 'matches'">
                            <img loading="lazy" src="@/assets/images/motion_play.svg"/>{{ $t('live-upcoming','Live & Upcoming')}}</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" :class="{ 'active': selectedTab === 'leagues' }" id="pills-leagues-tab" data-bs-toggle="pill"
                            data-bs-target="#pills-leagues" type="button" role="tab" aria-controls="pills-leagues"
                            aria-selected="false" @click="selectedTab = 'leagues'">
                            <img loading="lazy" src="@/assets/images/format-list-checks.svg"/>{{ $t('leagues','Leagues')}}</button>
                    </li>
                </ul>
            </div>
        </div>
    </section>

    <section v-if="selectedTab == 'matches'"> 
        <div class="go-back-league" v-if="leagueFilterActive">
            <span class="text-white back-cmn-btn" @click="resetMatches()"><i class="fa-solid fa-angle-left"></i></span>
            <span class="league-name-text mt-1 mb-2">{{ leagueName }}</span>
        </div>
    </section>
    <section class="details-inplay-game-sec sport-exch-wrapper" loading="lazy">
        <div class="remove-padding">
            <div class="row g-2">
                <SportsSideMenu :type="type" :leagues_list="leagues" @clicked="updatedMatches" />
                <div class="col-12 col-sm-12 col-md-12 col-lg-10 col-xl-10">
                    <div class="tab-content" id="pills-tabContent">
                        <div class="tab-pane fade show active" id="pills-live-upcoming" role="tabpanel"
                            aria-labelledby="pills-live-upcoming-tab" v-if="selectedTab == 'matches'">
                            <div class="inply-bet-details-sec">
                                <template v-if="loading">
                                    <div class="spinner-container">
                                        <div class="spinner-border text-danger" role="status">
                                            <span class="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                </template>
                                <template v-else-if="!loading && matches_list && matches_list.length > 0">
                                    <div class="v-expension-pannel-sec">
                                        <div class="accordion" id="accordionExample">
                                            <SportItemMatch :type="type" :sportsData="matches_list"/>
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <div >
                                        <NoDataFound/>
                                    </div>
                                </template>
                            </div>
                        </div>

                        <div class="tab-pane fade" id="pills-leagues" role="tabpanel" aria-labelledby="pills-leagues-tab">
                            <div class="leagues-details-sec" v-if="selectedTab == 'leagues'">
                                <div class="leagues-type-matches">
                                    <template v-if="Object.keys(leagues)?.length > 0">
                                        <ul>
                                            <li v-for="(league,l_index) in leagues" :key="l_index">
                                                <a class="text-white" @click="fliterLeagues(league,l_index)">{{ l_index }}</a>
                                            </li>
                                        </ul>
                                    </template>
                                    <template v-else>
                                        <NoDataFound/>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import { mapGetters } from 'vuex';
import { checkForLockedMatches, checkEventManageforSports } from '@/shared/services/eventLocks.js';

export default {
    name: "Sports",
    components:{
        SportsSideMenu: defineAsyncComponent(() =>
            import('../components/SportsSideMenu.vue')
        ),
        SportItemMatch: defineAsyncComponent(() =>
            import('../components/SportItemMatch.vue')
        ),
        MobileSports: defineAsyncComponent(() =>
            import('@/shared/components/sport-selection/mobileSpots.vue')
        ),
        NoDataFound: defineAsyncComponent(() =>
            import('@/shared/components/no-data/NoDataFound.vue')
        ),
    },
    computed: {
        ...mapGetters({
			sportsCount: 'sportsCount',
            favouriteGames: 'favouriteGames'
		}),
	},
    data() {
        return {
            type: this.$route?.params?.type,
            sport_id: this.$route.params.id,
            matches_list: [],
            matchesArray: [],
            leagueList: [],
            selectedLeague: [],
            leagues:{},
            leagueName:null,
            selectedTab:'matches',
            leagueFilterActive:false,
            loading: false,
        }
    },      
    created() {
        this.getSportsList();
        if(!this.sportsCount) {
            this.getTotalMatches();
        }
    },
    methods: {
        checkEventManageforSports,
        checkForLockedMatches,
        getSportsList() {
            this.loading = true;
            this.$apiCall('get', 'MATCHES_BY_SPORT_ID', null, 'sports', { sport_id: this.sport_id }).then(response => {
                this.loading = false;
                if (response) {
                    if (response.status == 200) {
                        this.matches_list=response.data.data
                        let lockedMatchIds = [];
                        let lockedLeagueIds = [];
                        if(this.$auth?.status && this.eventManage) {
                            lockedMatchIds = this.eventManage.find(item => item.type == 'match');
                            lockedLeagueIds = this.eventManage.find(item => item.type == 'league');

                            lockedMatchIds = lockedMatchIds && lockedMatchIds.type_id !== null ? lockedMatchIds.type_id.split(',') : [];
                            lockedLeagueIds = lockedLeagueIds && lockedLeagueIds.type_id !== null ? lockedLeagueIds.type_id.split(',') : []
                        }

                         for(var i=0;i<this.matches_list.length;i++){
                            if(this.checkEventManageforSports(this.matches_list[i]?.sport_id) && this.checkForLockedMatches(this.matches_list[i]?.matchId, this.matches_list[i]?.league_id, lockedMatchIds, lockedLeagueIds)) {
                                if(this.favouriteGames?.length && this.favouriteGames?.includes(parseInt(this.matches_list[i].event_id))){
                                    this.matches_list[i]['favourite']=true
                                }else{
                                    this.matches_list[i]['favourite']=false
                                }  
                                for(var j=0;j<this.matches_list[i].runners?.length;j++){
                                    for(var k=0;k<this.matches_list[i].runnerNames.length;k++){
                                        if(this.matches_list[i].runners[j].sid == this.matches_list[i].runnerNames[k].SID){
                                            this.matches_list[i].runners[j].runner_name = this.matches_list[i].runnerNames[k].RN
                                        }
                                    }
                                }   
                            }
                        }

                        this.leagues={}
                        this.matches_list?.forEach(item => {
                            const leagueName = item.league_name;
                            if (!this.leagues[leagueName]) {
                                this.leagues[leagueName] = [];
                            }
                            this.leagues[leagueName].push(item);
                            });
                    }
                }
            }).catch(error => {
                this.loading = false;
                console.log(error)
                if (error) {
                    this.$errorToast(error);
                }
            });
        },
        
        updatedMatches(league){
            this.matches_list=league;
            this.leagueName=league[0]?.league_name
            this.leagueFilterActive=true
        },
        fliterLeagues(league,league_name){
            this.selectedTab = 'matches'
            this.leagueFilterActive=true
            this.matches_list=league
            this.leagueName=league_name
            var elementLive = document.getElementById('pills-live-upcoming-tab')
            var elementLeague = document.getElementById('pills-leagues-tab')
            var tabsHeader = document.getElementById('tabs-header')
            elementLive.classList.add("active");
            elementLeague.classList.remove("active");
            tabsHeader.classList.add('hide')
        },
        resetMatches(){
            this.leagueFilterActive=false
            this.leagueName = null
            this.matches_list = [];
            this.getSportsList()
            this.selectedTab = 'matches'
            var tabsHeader = document.getElementById('tabs-header')
            tabsHeader.classList.remove('hide')
        },
        getTotalMatches() {
            this.loading = true;
            this.$apiCall('get', 'INPLAY_MATCHES_COUNT', null, 'sports').then(response => {
                this.loading = false;
                if (response) {
                    if (response.status == 200) {
                        this.totalMatches = response.data.data
                        this.$store.dispatch('SetSportsCount', response.data.data)
                    }
                }
            })
        },
    }
};
</script>

<style scoped>
.league-name-text {
    color: #fff !important;
    font-size: 14px;
}
.light .league-name-text {
    color: #000 !important;
}
.hide {
    display: none;
}

.spinner-container {
    display: flex;
    justify-content: center;  /* Center horizontally */
    align-items: center;      /* Center vertically */
    height: 100%;             /* Or any fixed height if preferred */
    width: 100%;              /* Ensure it covers the container's width */
    position: absolute;       /* Position it relative to its parent container */
    top: 0;
    left: 0;
}


</style>